import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useEffect, useState, useCallback } from 'react';
import { subscribe, unsubscribe } from '@wh/message-bus';
import Modal from '../Modal';
import { SelfExcluded } from '../SelfExcluded';
import { AccountClosed } from '../AccountClosed';
import { TimeOutResult } from '../TimeOutResult';
import { TranslatorProvider } from '@wh/ui-translations';

import { TRANSLATION_CONTEXT } from '../../componentConfig';

var MODAL_COMPONENTS = {
  timeOutResult: TimeOutResult,
  selfExcluded: SelfExcluded,
  accountClosed: AccountClosed
};

var SaferGamblingModals = function SaferGamblingModals(_ref) {
  var translations = _ref.translations;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      modalProps = _useState2[0],
      setModalProps = _useState2[1];

  var close = useCallback(function () {
    return setModalProps(null);
  }, []);

  useEffect(function () {
    var id = subscribe('wh.myAccount.command.modals.open.safergambling', function (_, params) {
      setModalProps(params);
    });
    return function () {
      unsubscribe(id);
    };
  }, []);

  if (!modalProps) {
    return null;
  }

  var ModalComponent = MODAL_COMPONENTS[modalProps.type];
  var title = translations[TRANSLATION_CONTEXT].header.title[modalProps.type];

  return React.createElement(
    Modal,
    { onClose: close, visible: true, title: title },
    React.createElement(
      TranslatorProvider,
      { translations: translations },
      React.createElement(ModalComponent, modalProps)
    )
  );
};

export default SaferGamblingModals;